import type { AxiosError } from 'axios'
import type { ApiError, ErrorResponseData } from '../types'
import { ERROR_MESSAGES, HTTP_STATUS } from '../constants'
import { isEmpty } from '../../utils/CommonFunctions';

export const handleApiError = (error: AxiosError<ErrorResponseData>): ApiError => {
  if (!error.response) {
    return {
      message: ERROR_MESSAGES.NETWORK_ERROR,
      code: error.code,
      status: 0,
    }
  }

  const status = error.response?.status;
  let message = ''
  
  if (error.response.data && error.response.data) {
    if (error.response.data.message) {
      message = error.response.data.message
    }
    console.log(error.response.data)
    console.log(error.response.data.message)
    //TODO: what is hppening here
  } 

  if (isEmpty(message)) {
    message = ERROR_MESSAGES[status as keyof typeof ERROR_MESSAGES] || ERROR_MESSAGES.DEFAULT ;
  }
  

  return {
    message,
    status,
    code: error.code,
  }
}

export const isAuthError = (status: number): boolean => {
  return status === HTTP_STATUS.UNAUTHORIZED || status === HTTP_STATUS.FORBIDDEN
}